import React from 'react';

import { ASLVideoHistory } from 'features/assetManagement';
import styles from './ASLVideoHistoryPage.module.scss';

function ASLVideoHistoryPage() {
  return (
    <div className={styles.videoUploadPage}>
      <ASLVideoHistory />
    </div>
  );
}

export default ASLVideoHistoryPage;
